import * as angular from 'angular';
import {IController} from "angular";
import {ServicesViewsStateType} from "../../types/services-views-state.type";

export class ServicesAssignAgentSettingsPanelComponent implements IController {
  settings: any;
  onSettingsChange: Function;

  /* @ngInject */
  constructor(private $mdPanel) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          columns: angular.copy(this.settings.columns),
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./template/panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignAgentSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&',
    },
    template: require('./services-assign-agent-settings-panel.html').default,
    controller: ServicesAssignAgentSettingsPanelComponent
  });

class DeliveriesSettingsCtrl implements IController {

  private settingsConfig: any;

  public pageName: string;

  constructor(private mdPanelRef, private deliveriesConstants, private $state, private commonsConstants) {

  }

  $onInit() {
    this.pageName = this.$state.current.name;

    this.settingsConfig = {
      columns: this.mdPanelRef.config.locals.data.columns
    };

  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsConfig.columns[columnKey].enabled = isEnabled;
  }

  onReset() {
    this.settingsConfig = {
      columns: this.deliveriesConstants.servicesAssignAgentTableColumns,
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.settingsConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }

}

